
/* EMAIL */
export function formUtilsCheckEmail() {
    this.isEmailEmpty = this.form.email.length > 0 ? false : true;

    let regex =
      /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
  
    this.errors.email = !regex.test(String(this.form.email).toLowerCase());
}


/* MOUSE HOVER */
export function formUtilsMouseHoverEffect(event, refIn) {
  var a = event.clientX;
  var b = this.$refs[refIn].getBoundingClientRect().x;

  this.topX = event.clientY - this.$refs[refIn].getBoundingClientRect().y;
  this.leftX = a - b;
}

/* ANIMATION */
export function formUtilsCheckAnimation() {
  setTimeout(() => {
    const autofilledInput = document.querySelector('input:-webkit-autofill');
    if(autofilledInput) {
      if (typeof this.isPasswordEmpty != 'undefined') {
        this.isPasswordEmpty = false;
      }
      if (typeof this.isEmailEmpty != 'undefined') {
        this.isEmailEmpty = false;
      }
      if (typeof this.isOldPasswordEmpty != 'undefined') {
        this.isOldPasswordEmpty = false;
      }
      if (typeof this.isConfirmPasswordEmpty != 'undefined') {
        this.isConfirmPasswordEmpty = false;
      }
    }
  }, 300);
}





/* ON */
export function formUtilsOnPaste(e){
  e.preventDefault();
}
export function formUtilsonPasteConfirm(){
  // e.preventDefault();
}




/* PASSWORD */
export function formUtilsCheckPassword() {
  this.isPasswordEmpty = this.form.password.length > 0 ? false : true;
}

export function formUtilsCheckPasswordSave() {
  let regex = /(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}/;

  this.isPasswordEmpty = this.form.password.length > 0 ? false : true;
  this.errors.password = !regex.test(this.form.password);
}


export function formUtilsShowPassword() {
  this.passwordType =
    this.passwordType === "password" ? "text" : "password";
  this.isPasswordEyeSlashClass =
    this.passwordType === "password" ? true : false;
}


/* OLD PASSWORD */
export function formUtilsCheckOldPassword() {
  let regex = /(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}/;

  this.isOldPasswordEmpty = this.form.oldPassword.length > 0 ? false : true;
  this.errors.oldPassword = !regex.test(this.form.oldPassword);
}

export function formUtilsShowOldPassword() {
  this.oldPasswordType =
    this.oldPasswordType === "password" ? "text" : "password";
  this.isOldPasswordEyeSlashClass =
    this.oldPasswordType === "password" ? true : false;
}



/* CONFIRM PASSWORD */
export function formUtilsCheckPasswordConfirmation() {
	this.isConfirmPasswordEmpty = this.form.passwordConfirmation.length > 0 ? false : true;

	this.isPasswordConfirmationEmpty = this.form.passwordConfirmation.length > 0 ? false : true;
	this.errors.passwordConfirmation = this.form.passwordConfirmation == this.form.password ? false : true;
}

export function formUtilsShowConfirmationPassword() {
  this.passwordConfirmationType =
    this.passwordConfirmationType === "password" ? "text" : "password";
  this.isConfirmationPasswordEyeSlashClass =
    this.passwordConfirmationType === "password" ? true : false;
}




/* TERM AND CONDITION */
export function formUtilsTermAndCondition() {
  this.termsAndConditionsCheckbox =
    this.termsAndConditionsCheckbox === false ? true : false;

  this.errors.termsAndConditionsCheckbox =
    this.termsAndConditionsCheckbox === false ? true : false;
}

export function formUtilsCheckTermsAndCondition() {
  this.errors.termsAndConditionsCheckbox =
    this.termsAndConditionsCheckbox === false ? true : false;
}

/* OTHER */
export function formUtilsClearError() {
  this.showToastError = false;
}

export function formUtilsCheckVerificationCodeEmpty() {
  this.showToastError = false;
  this.isVerificationCodeEmpty =
    this.form.verificationCode.length > 0 ? false : true;
}

export function formUtilsValidateInputEmptySpaces(e) {
	if (e.keyCode == 32 || e.key === "+") e.preventDefault();

	if (this.form.email.length >= 255) {
		this.errors.maxCharacter = true;
		e.preventDefault();
	}
}

export function formUtilsCancel() {
  this.$router.back();
  return;
}

/* ADDRESS AND CITY */
export function formUtilsCheckAddress() {
  this.isAddressEmpty = this.address !== null ? false : true;
}
export function formUtilsCheckPostalCode() {
  this.isPostalCodeEmpty = this.postalCode !== null ? false : true;
}
export function formUtilsCheckCity() {
  this.isCityEmpty = this.city !== null ? false : true;
}

/* PHONE */
export function formUtilsValidateSloveniaPhoneNumber() {
  if (this.phone.length !== 8) {
    return false;
  }

  const mobilePrefixes = ['030', '040', '068', '069', '031', '041', '051', '065', '070', '071', '064', '059', '081', '082', '083'];

  const prefix = '0' + this.phone.substring(0, 2);

  if (mobilePrefixes.includes(prefix) === true) {
    return true;
  }

  const landLinePrefixes = ['01', '02', '03', '04', '05', '06', '07'];

  const landline = '0' + this.phone.substring(0, 1);

  if (landLinePrefixes.includes(landline) === true) {
    return true;
  }
}





